import { CheckboxMarkedCirclePlusOutlineIcon } from './CheckboxMarkedCirclePlusOutlineIcon';

/**
 * author: Teodor Sandu
 * id 488DC51C-ABAF-4017-885B-84D3BBDE4B42
 * name checkbox-marked-circle-plus-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-marked-circle-plus-outline.svg
 * tags
 * - Form 
 */
export const TodoPlusIcon = CheckboxMarkedCirclePlusOutlineIcon;
export default TodoPlusIcon